import axios from "axios";
import Api from "./api";

class ProductService extends Api {
  getHomeOffers() {
    return axios({ url: `/${this.ressource}/promotions`, method: "GET" });
  }
  getOffers(filters = {}) {
    return this.getAll({ offers: 1, limit: 999, ...filters });
  }
  getFilters() {
    return axios({ url: "/available_filters", method: "GET" });
  }
}

export default new ProductService({
  ressource: "products"
});
